import { Box, theme } from '@capitalise/ui-design-system';
import { slideInRight } from 'modules/Business/shared/animations';
import styled from 'styled-components';

export const StyledHr = styled.hr`
  padding: 0;
  margin: 0;
  border-color: ${theme.colors['grey-100']};
`;

export const GapFlexBox = styled(Box)`
  gap: 8px;
`;

export const slideRightCss = (index) => `
  ${slideInRight}
  animation-duration: ${0.5 + index * 0.15}s;
`;
